import React, { useState, useRef, useEffect } from 'react';
import EssentialsTemplate from './EssentialsTemplate';
import { essentialsCategories, essentialsNameMapping, hardcodedEssentials } from '../../../Constants/Data';
import { useLocation } from 'react-router-dom';
const EssentialsTab = () => {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash; 
        const elementId = hash.replace('#', ''); 
        console.log(elementId);

        switch (elementId) {
            case "labs-diagnostic-centers":
                let labElement = document.getElementById("Lab Integrations");
                if (labElement) {
                    handleCategoryClick("Lab Integrations");
                    labElement.scrollIntoView({ behavior: 'smooth' });
                }
                break;
            case "devices":
                let deviceElement = document.getElementById("Devices");
                if (deviceElement) {
                    handleCategoryClick("Devices");
                    deviceElement.scrollIntoView({ behavior: 'smooth' });
                }
                break;
        }
    }, [location]);

    const [categoriesExpanded, setCategoriesExpanded] = useState(true);

    const handleSidebarClick = () => {
        setCategoriesExpanded(!categoriesExpanded);
    };

    const [contentExpanded, setContentExpanded] = useState(
        essentialsCategories.reduce((acc, label, index) => {
            acc[label] = index === 0 ? false : true;
            return acc;
        }, {})
    );

    const handleContentClick = (label) => {
        setContentExpanded((prev) => ({
            ...prev,
            [label]: !prev[label],
        }));
    };

    const [selectedCategory, setSelectedCategory] = useState(essentialsCategories[0]);
    const [scrollTarget, setScrollTarget] = useState(null);

    const categoryRefs = useRef(essentialsCategories.reduce((acc, label) => {
        acc[label] = React.createRef();
        return acc;
    }, {}));

    const handleCategoryClick = (label) => {
        setSelectedCategory(label);
        setContentExpanded((prev) => {
            const newState = { ...prev };
            essentialsCategories.forEach((lbl) => {
                newState[lbl] = lbl !== label;
            });
            return newState;
        });
        setScrollTarget(label);
    };

    useEffect(() => {
        if (scrollTarget !== null) {
            categoryRefs.current[scrollTarget].current.scrollIntoView({ behavior: 'smooth' });
            setScrollTarget(null);
        }
    }, [scrollTarget, contentExpanded]);

    const [isSignedIn, setIsSignedIn] = useState(false);

    async function currentSession() {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const idToken = sessionStorage.getItem('idToken');

            if (idToken != null && accessToken != null) {
                setIsSignedIn(true);
            } else {
                setIsSignedIn(false);
            }
        } catch (err) {
            setIsSignedIn(false);
        }
    }

    useEffect(() => {
        currentSession();
    }, []);


    const retrieveEssentialsStatuses = async () => {
        const fetchData = async (url, storageKey) => {
            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                sessionStorage.setItem(storageKey, JSON.stringify(data.data));
                return data;
            } catch (error) {
                console.error(`Error fetching ${storageKey}:`, error);
                return null;
            }
        };
        try {
            const [addonsData, pmData] = await Promise.all([
                fetchData("https://ehr2.charmtracker.com/api/ehr/v1/addons/ehr", 'addons'),
                fetchData("https://ehr2.charmtracker.com/api/ehr/v1/addons/pm", 'pm')
            ]);
            return { addons: addonsData.data, pm: pmData.data };
        } catch (error) {
            console.error('Error retrieving statuses:', error);
            return { addons: null, pm: null };
        }
    };


    // useEffect(() => {
    //     const updateProductStatuses = async () => {
    //         const statuses = {};
    //         for (const product of hardcodedEssentials) {
    //             const status = await checkStatus(product);
    //             statuses[product.name] = status;
    //         }
    //         setProductStatuses(statuses);
    //     };

    //     if (retrievedAddons || retrievedPm) {
    //         updateProductStatuses();
    //     }
    // }, [retrievedAddons, retrievedPm]);

    // const [retrievedAddons, setRetrievedAddons] = useState(null);
    // const [retrievedPm, setRetrievedPm] = useState(null);

    const [productStatuses, setProductStatuses] = useState([]);

    const updateProductStatuses = async () => {

        await retrieveEssentialsStatuses();

        let retrievedAddons = JSON.parse(sessionStorage.getItem('addons'));
        let retrievedPm = JSON.parse(sessionStorage.getItem('pm'));

        const statuses = [];
        for (const product of hardcodedEssentials) {
            switch (product.category) {
                case "Lab Integrations":
                    if (retrievedAddons.lab_integrations && Array.isArray(retrievedAddons.lab_integrations)) {
                        const foundLab = retrievedAddons.lab_integrations.find(addon => addon.lab_name === product.name);
                        if (foundLab) {
                            statuses.push({ product: product.name, status: foundLab.status });
                        }
                        else {
                            statuses.push({ product: product.name, status: "Integrate" });
                        }
                    }
                    else {
                        statuses.push({ product: product.name, status: "Integrate" });
                    }
                    break;
                case "Devices":
                    if (retrievedPm.external_devices && Array.isArray(retrievedPm.external_devices)) {
                        const foundDevice = retrievedPm.external_devices.find(addon => addon.device_type === product.name);
                        if (foundDevice) {
                            statuses.push({ product: product.name, status: foundDevice.status });
                        }
                        else {
                            statuses.push({ product: product.name, status: "Integrate" });
                        }
                    }
                    else {
                        statuses.push({ product: product.name, status: "Integrate" });
                    }
                    break;
                default:
                    const productName = essentialsNameMapping[product.name]?.name;

                    if (productName) {
                        if (productName in retrievedAddons) {
                            statuses.push({ product: product.name, status: retrievedAddons[productName].status });
                        } else if (productName in retrievedPm) {
                            statuses.push({ product: product.name, status: retrievedPm[productName].status });
                        }
                        else {
                            statuses.push({ product: product.name, status: "Integrate" });
                        }
                    }
                    else {
                        statuses.push({ product: product.name, status: "Integrate" });
                    }
            }
        }
        setProductStatuses(statuses);
    }



    const fetchStatuses = async () => {
        await retrieveEssentialsStatuses();
        await updateProductStatuses();
    };

    useEffect(() => {
        if (isSignedIn) {
            fetchStatuses();
        }
    }, [isSignedIn]);


    return (
        <div className="w-full min-h-screen flex flex-row bg-marketplaceBackground">
            {categoriesExpanded ? (
                <div className="hidden md:block min-w-[320px] min-h-screen bg-gradient-to-b from-[#28051E] to-[#882B67]">
                    <div className="w-full h-fit mt-[46px] flex items-center relative">
                        <h3 className="w-full text-center font-medium text-xl md:text-3xl text-exploreCategoriesText">Categories</h3>
                        <button className="w-[48px] h-[36px] bg-[#640444] absolute right-0 top-0 rounded-l-full flex items-center justify-center" onClick={() => handleSidebarClick()}>
                            <svg className="mr-1" width="12" height="12" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                    <div className="hidden w-full mt-[20px] md:flex flex-col">
                        {essentialsCategories.map((label, index) => (
                            <button
                                key={index}
                                className={`font-proximanova text-white text-[19px] py-[12px]
                                    ${selectedCategory === label ? 'bg-exploreCategoriesBackground font-[600]' : 'bg-clear font-[400]'}`}
                                onClick={() => handleCategoryClick(label)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            ) :
                <button className="w-[48px] min-w-[48px] h-[36px] mt-[46px] bg-[#640444] rounded-r-full flex items-center justify-center" onClick={() => handleSidebarClick()}>
                    <svg className="mr-1" width="12" height="12" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.9953 8.59269C11.9953 8.81799 11.8915 9.04322 11.6693 9.22105L2.77709 16.3349C2.34732 16.6787 1.63592 16.6787 1.20612 16.3349C0.776345 15.9911 0.776345 15.422 1.20612 15.0781L9.31282 8.59277L1.20612 2.10742C0.776345 1.7636 0.776345 1.19448 1.20612 0.85064C1.6359 0.506818 2.3473 0.506818 2.77709 0.85064L11.6693 7.9645C11.8915 8.14233 11.9953 8.36762 11.9953 8.59285V8.59269Z" fill="white" />
                    </svg>
                </button>
            }

            {hardcodedEssentials && (
                <div className="flex flex-grow flex-col pb-12 min-h-screen h-fit md:h-screen md:overflow-y-auto px-[32px] 1.5xl:px-[48px]">
                    {essentialsCategories.map((label, index) => (
                        <div key={index} ref={categoryRefs.current[label]} id={label}>

                            <div className="mt-[42px] flex flex-row justify-between border-b-[1px] pb-2 border-exploreCategoriesBackground">
                                <h3 className="font-allroundgothic text-[20px] font-[600]">
                                    {label}
                                </h3>

                                <button className="" onClick={() => handleContentClick(label)}>
                                    {!contentExpanded[label] ? (
                                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.43937 0.0370601C8.66467 0.0370601 8.8899 0.14081 9.06773 0.363099L16.1816 9.25526C16.5254 9.68503 16.5254 10.3964 16.1816 10.8262C15.8378 11.256 15.2686 11.256 14.9248 10.8262L8.43945 2.71953L1.9541 10.8262C1.61027 11.256 1.04116 11.256 0.69732 10.8262C0.353498 10.3964 0.353498 9.68505 0.69732 9.25526L7.81118 0.363099C7.98901 0.140815 8.2143 0.0370601 8.43953 0.0370601H8.43937Z" fill="#9A016A" />
                                        </svg>
                                    )
                                        :
                                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.43953 11.1485C8.21424 11.1485 7.989 11.0448 7.81118 10.8225L0.697319 1.93035C0.353498 1.50057 0.353498 0.789175 0.697319 0.359381C1.04114 -0.070396 1.61026 -0.070396 1.9541 0.359381L8.43945 8.46608L14.9248 0.359381C15.2686 -0.070396 15.8378 -0.070396 16.1816 0.359381C16.5254 0.789159 16.5254 1.50056 16.1816 1.93035L9.06773 10.8225C8.8899 11.0448 8.6646 11.1485 8.43937 11.1485H8.43953Z" fill="#9A016A" />
                                        </svg>
                                    }
                                </button>
                            </div>

                            {!contentExpanded[label] && (
                                <div className={`mt-[30px] grid grid-cols-1 xl:grid-cols-2 1.5xl:grid-cols-3 3xl:grid-cols-4 gap-[22px]`}>
                                    {hardcodedEssentials
                                        .filter((product) => product.category === label)
                                        .map((product) => {
                                            return (
                                                <div key={product.id} >
                                                    <EssentialsTemplate
                                                        loginStatus={isSignedIn}
                                                        name={product.name}
                                                        description={product.description}
                                                        initialRequestStatus={productStatuses.find(status => status.product === product.name)?.status || "Integrate"}
                                                        category={product.category}
                                                        link={product.thumbnail}
                                                        redirect={
                                                            product.category === "Devices" ? essentialsNameMapping["External Devices"]?.redirect : product.category === "Lab Integrations" ? essentialsNameMapping["Lab Integrations"]?.redirect
                                                                : essentialsNameMapping[product.name]?.redirect
                                                                ?? undefined
                                                        } />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div >
    );
}

export default EssentialsTab;